export default __webpack_public_path__ + "static/media/background.c178575a.svg";